// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangRouteImport } from './routes/$lang'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BookRouteImport } from './routes/book'
import { Route as GuideRouteImport } from './routes/guide'
import { Route as TrustRouteImport } from './routes/trust'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthSetPasswordRouteImport } from './routes/auth.set-password'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BookIndexRouteImport } from './routes/book.index'
import { Route as BookLangRouteImport } from './routes/book.$lang'
import { Route as ContractTokenRouteImport } from './routes/contract.$token'
import { Route as GuestInfoTokenRouteImport } from './routes/guest-info.$token'
import { Route as MediaTokenRouteImport } from './routes/media.$token'
import { Route as PayTokenRouteImport } from './routes/pay.$token'
import { Route as ReviewTokenRouteImport } from './routes/review.$token'
import { Route as ThankYouTokenRouteImport } from './routes/thank-you.$token'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LangRoute = LangRouteImport.update({
            id: '/$lang',path: '/$lang',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const GuideRoute = GuideRouteImport.update({
            id: '/guide',path: '/guide',getParentRoute: () => rootRouteImport
          })
const TrustRoute = TrustRouteImport.update({
            id: '/trust',path: '/trust',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthSetPasswordRoute = AuthSetPasswordRouteImport.update({
            id: '/set-password',path: '/set-password',getParentRoute: () => AuthRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const BookIndexRoute = BookIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BookRoute
          })
const BookLangRoute = BookLangRouteImport.update({
            id: '/$lang',path: '/$lang',getParentRoute: () => BookRoute
          })
const ContractTokenRoute = ContractTokenRouteImport.update({
            id: '/contract/$token',path: '/contract/$token',getParentRoute: () => rootRouteImport
          })
const GuestInfoTokenRoute = GuestInfoTokenRouteImport.update({
            id: '/guest-info/$token',path: '/guest-info/$token',getParentRoute: () => rootRouteImport
          })
const MediaTokenRoute = MediaTokenRouteImport.update({
            id: '/media/$token',path: '/media/$token',getParentRoute: () => rootRouteImport
          })
const PayTokenRoute = PayTokenRouteImport.update({
            id: '/pay/$token',path: '/pay/$token',getParentRoute: () => rootRouteImport
          })
const ReviewTokenRoute = ReviewTokenRouteImport.update({
            id: '/review/$token',path: '/review/$token',getParentRoute: () => rootRouteImport
          })
const ThankYouTokenRoute = ThankYouTokenRouteImport.update({
            id: '/thank-you/$token',path: '/thank-you/$token',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const AuthRouteChildren = {
  AuthSetPasswordRoute: AuthSetPasswordRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const BookRouteChildren = {
  BookLangRoute: BookLangRoute,BookIndexRoute: BookIndexRoute
}

const BookRouteWithChildren = BookRoute._addFileChildren(BookRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,LangRoute: LangRoute,AuthRoute: AuthRouteWithChildren,BookRoute: BookRouteWithChildren,GuideRoute: GuideRoute,TrustRoute: TrustRoute,BlogSlugRoute: BlogSlugRoute,ContractTokenRoute: ContractTokenRoute,GuestInfoTokenRoute: GuestInfoTokenRoute,MediaTokenRoute: MediaTokenRoute,PayTokenRoute: PayTokenRoute,ReviewTokenRoute: ReviewTokenRoute,ThankYouTokenRoute: ThankYouTokenRoute,BlogIndexRoute: BlogIndexRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)